export const ausschreibungU20RugbyBundesliga202627 = {
  "id": "ausschreibung-u20-rugby-bundesliga-2026-27",
  "title": "Ausschreibung zur U20 Rugby Bundesliga 2026/2027",
  "slug": "ausschreibung-u20-rugby-bundesliga-2026-27",
  "publishedAt": "2026-08-04T12:00:00Z",
  "author": "Rugby-Bundesliga-Ausschuss",
  "language": "de",
  "readTime": "4 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "U20",
    "Ausschreibung",
    "Nachwuchs",
    "Spielbetrieb"
  ],
  "excerpt": "Die U20 Rugby Bundesliga geht in die Saison 2026/2027. Mit vier verbindlichen Spielterminen soll ein kleiner, aber verlässlicher Spielbetrieb geschaffen werden. Vereine und Landesverbände können ihre Mannschaften bis zum 21. August 2026 anmelden.",
  "img": "/images/u20-rugby-bundesliga-ausschreibung-2026-27.png",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Der Übergang vom Jugendbereich in den Erwachsenenspielbetrieb ist eine der entscheidenden Phasen in der sportlichen Entwicklung junger Rugbyspieler. Gerade nach dem Ende der regulären Jugendspielberechtigung fehlt vielen Spielern ein altersgerechtes Wettbewerbsangebot, das ihnen ausreichend Spielpraxis bietet und sie schrittweise an die Anforderungen des Erwachsenenrugby heranführt. Ohne eine solche Möglichkeit besteht die Gefahr, dass Spieler den Anschluss verlieren, nur unregelmäßig eingesetzt werden oder dem Rugbysport vollständig den Rücken kehren."
    },
    {
      "type": "paragraph",
      "content": "Ein verlässlicher U20 Spielbetrieb kann diese Lücke schließen. Er bietet jungen Spielern die Möglichkeit, sich unter vergleichbaren körperlichen und sportlichen Voraussetzungen weiterzuentwickeln, Verantwortung auf dem Spielfeld zu übernehmen und wertvolle Wettkampferfahrung zu sammeln. Gleichzeitig unterstützt er die Vereine dabei, Nachwuchsspieler dauerhaft in ihre Mannschaftsstrukturen zu integrieren und gezielt auf Einsätze im Erwachsenenbereich vorzubereiten."
    },
    {
      "type": "paragraph",
      "content": "Darüber hinaus schafft ein U20 Wettbewerb bessere Voraussetzungen für die Sichtung und Förderung talentierter Spieler. Regelmäßige Spiele ermöglichen eine belastbarere Einschätzung der individuellen Entwicklung als einzelne Lehrgänge oder Trainingseinheiten. Zugleich können die Zusammenarbeit zwischen Vereinen, Landesverbänden und Nationalmannschaften gestärkt sowie gemeinsame Entwicklungswege für junge Spieler aufgebaut werden."
    },
    {
      "type": "paragraph",
      "content": "Der U20 Spielbetrieb ist damit ein wichtiger Bestandteil einer nachhaltigen Spielerentwicklung. Er verbindet die Nachwuchsarbeit mit dem Erwachsenenrugby, erhöht die Bindung der Spieler an ihre Vereine und schafft zusätzliche sportliche Perspektiven. Langfristig kann eine etablierte U20 Rugby Bundesliga außerdem zur Stärkung der Vereinsmannschaften, der Bundesligen und der deutschen Nationalmannschaften beitragen."
    },
    {
      "type": "paragraph",
      "content": "Die Liga befindet sich weiterhin im Aufbau. In der vergangenen Saison konnten die vorgesehenen Spiele aufgrund von Überschneidungen im Rugbykalender und eines langen Winters leider nicht stattfinden. Aus den dabei gewonnenen Erfahrungen wurde die Planung für die Saison 2026/2027 angepasst."
    },
    {
      "type": "paragraph",
      "content": "Mit einer überschaubaren Zahl verbindlicher Spieltermine soll zunächst ein kleiner, aber verlässlicher Spielbetrieb geschaffen werden. Dieser soll gemeinsam mit den teilnehmenden Vereinen und Landesverbänden schrittweise weiterentwickelt werden und in den kommenden Jahren sowohl hinsichtlich der Zahl der Mannschaften als auch hinsichtlich des Spielumfangs wachsen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "1. Teilnahme und Anmeldung"
    },
    {
      "type": "paragraph",
      "content": "Teilnehmen können Mannschaften, die durch einen Verein oder einen Landesverband gemeldet werden. Voraussetzung für die Teilnahme ist eine offizielle schriftliche Teilnahmeerklärung des jeweiligen Vereins oder Landesverbandes."
    },
    {
      "type": "paragraph",
      "emphasis": "strong",
      "content": "Die Teilnahmeerklärung muss spätestens bis zum 21. August 2026 per E Mail an rba-vorsitz@rugbydeutschland.org eingegangen sein."
    },
    {
      "type": "paragraph",
      "content": "Die Anmeldung ist verbindlich und umfasst die Teilnahme an allen vorgesehenen Spielterminen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "2. Spielberechtigung"
    },
    {
      "type": "paragraph",
      "content": "Für den Einsatz in der U20 Rugby Bundesliga gelten folgende Voraussetzungen:"
    },
    {
      "type": "list",
      "items": [
        "Alle eingesetzten Spieler müssen über einen gültigen Spielerpass verfügen, der sie für den Spielbetrieb in der Regionalliga oder Bundesliga berechtigt.",
        "Die Spieler müssen am jeweiligen Spieltag mindestens 18 Jahre alt sein.",
        "Das Höchstalter der eingesetzten Spieler beträgt 25 Jahre.",
        "Im Spieltagskader einer Mannschaft dürfen sich höchstens vier Spieler befinden, die älter als 20 Jahre sind."
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Durch die begrenzte Einbindung älterer Spieler soll den Mannschaften eine ausreichende personelle Stabilität ermöglicht werden. Der sportliche Schwerpunkt des Wettbewerbs bleibt jedoch eindeutig auf der Entwicklung und Förderung junger Spieler im Übergang zum Erwachsenenrugby gerichtet."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "3. Verbindliche Spieltermine"
    },
    {
      "type": "paragraph",
      "content": "Mit der Anmeldung verpflichtet sich jede Mannschaft, an den folgenden vier Terminen am Spielbetrieb teilzunehmen:"
    },
    {
      "type": "list",
      "items": [
        "24.10.2026",
        "31.10.2026",
        "27.02.2027",
        "26.06.2027"
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Die konkreten Spielpaarungen, Anfangszeiten und Austragungsorte werden nach Abschluss des Meldeverfahrens gemeinsam mit den teilnehmenden Mannschaften abgestimmt und anschließend verbindlich festgelegt."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "4. Verbindlichkeit und Entschädigung bei Nichtantritt"
    },
    {
      "type": "paragraph",
      "content": "Die Verlässlichkeit des Spielbetriebs ist eine wesentliche Voraussetzung für den Aufbau der U20 Rugby Bundesliga. Mit der Anmeldung erklären sich die teilnehmenden Vereine und Landesverbände deshalb ausdrücklich bereit, die vereinbarten Spiele an den vorgesehenen Terminen auszutragen."
    },
    {
      "type": "paragraph",
      "content": "Für den Fall eines Nichtantritts wird eine Gebühr erhoben. Die Höhe dieser Gebühr sowie die genauen Voraussetzungen ihrer Erhebung werden von allen teilnehmenden Mannschaften in einem gemeinsamen Abstimmungsgespräch vor Beginn des Spielbetriebs beschlossen."
    },
    {
      "type": "paragraph",
      "content": "Die Gebühr wird dem gegnerischen Team als Entschädigung für entstandene Aufwendungen und den ausgefallenen Spielbetrieb zugeführt."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "5. Spielorte und Anbindung an die Nationalmannschaften"
    },
    {
      "type": "paragraph",
      "content": "Es besteht die Möglichkeit, einzelne Spiele in räumlicher und zeitlicher Nähe zu Lehrgängen der Herrennationalmannschaften auszutragen. Dadurch sollen die Sichtung der teilnehmenden Spieler gefördert und eine stärkere Verbindung zwischen dem U20 Spielbetrieb und den Nationalmannschaften geschaffen werden."
    },
    {
      "type": "paragraph",
      "content": "Eine solche Verbindung bietet den Spielern zusätzliche Motivation und ermöglicht den verantwortlichen Trainern eine unmittelbare Beobachtung unter Wettkampfbedingungen. Gleichzeitig können den jungen Spielern die sportlichen Anforderungen und Entwicklungsperspektiven innerhalb der Nationalmannschaftsstrukturen nähergebracht werden."
    },
    {
      "type": "paragraph",
      "content": "Ob und an welchen Terminen eine solche Verbindung organisatorisch umgesetzt werden kann, wird nach Abschluss des Meldeverfahrens mit den endgültig teilnehmenden Vereinen und Landesverbänden besprochen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "6. Gemeinsame Abstimmung vor Saisonbeginn"
    },
    {
      "type": "paragraph",
      "content": "Nach Ablauf der Meldefrist findet mit allen gemeldeten Vereinen und Landesverbänden ein gemeinsames Abstimmungsgespräch statt. Dabei sollen insbesondere folgende Punkte verbindlich geregelt werden:"
    },
    {
      "type": "list",
      "items": [
        "Die endgültigen Spielpaarungen",
        "Die Austragungsorte",
        "Die Anfangszeiten",
        "Die organisatorischen Verantwortlichkeiten",
        "Die Höhe und Anwendung der Gebühr bei einem Nichtantritt",
        "Die mögliche Verbindung einzelner Spiele mit Lehrgängen der Nationalmannschaften"
      ],
      "ordered": false
    },
    {
      "type": "heading",
      "level": 2,
      "content": "7. Zielsetzung"
    },
    {
      "type": "paragraph",
      "content": "Das unmittelbare Ziel für die Saison 2026/2027 ist die zuverlässige Durchführung der vier vorgesehenen Spieltermine. Auf dieser Grundlage soll gemeinsam mit den teilnehmenden Vereinen und Landesverbänden ein dauerhaftes und wachsendes Wettbewerbsformat entwickelt werden."
    },
    {
      "type": "paragraph",
      "content": "Alle interessierten Vereine und Landesverbände sind herzlich eingeladen, sich an diesem Aufbau zu beteiligen und jungen Spielern damit eine wichtige sportliche Perspektive zwischen Jugendrugby und Erwachsenenspielbetrieb zu eröffnen."
    }
  ]
};
